import { gql } from '@apollo/client';
export const FILTER_FIELDS = gql `
  fragment FilterFields on Filter {
    id
    createdAt
    updatedAt
    clientId
    returnType
    name
    description
    criteria
  }
`;
export const FILTERS = gql `
  ${FILTER_FIELDS}
  query FILTERS($spec: FilterSpec!) {
    filters(spec: $spec) {
      ...FilterFields
    }
  }
`;
export const SAVE_FILTER = gql `
  ${FILTER_FIELDS}
  mutation SAVE_FILTER($input: FilterInput!) {
    saveFilter(input: $input) {
      ...FilterFields
    }
  }
`;
export const DELETE_FILTER = gql `
  ${FILTER_FIELDS}
  mutation DELETE_FILTER($id: Int!) {
    deleteFilter(id: $id) {
      ...FilterFields
    }
  }
`;
